export default {
  // Success/Completion states - Green shades
  Completed: "#28a745", // Success green (darker, more professional)
  Approved: "#28a745", // Success green (darker, more professional)
  Delivered: "#28a745", // Same as completed
  Shipped: "#20c997", // Teal green (shipped but not delivered)
  Prepay: "#28a745", // Success green

  // In Progress states - Blue shades
  Confirmed: "#007bff", // Primary blue (confirmed orders)
  "In Transit": "#17a2b8", // Cyan blue (actively moving)
  Scheduled: "#6c757d", // Gray (scheduled but not started)

  // Active/Draft states - Cyan/Turquoise
  Draft: "#17d1ea", // Bright cyan (draft/work in progress)

  // Warning states - Yellow/Orange shades
  Pending: "#ffc107", // Amber/yellow (needs attention)
  "Pending For Approval": "#ffc107", // Amber/yellow (needs attention)
  Reserve: "#fd7e14", // Orange (reserved/hold)

  // In Progress/Processing - Teal
  Processed: "#20c997", // Teal (processed but not completed)

  // Delayed states - Red shades
  Delayed: "#dc3545", // Danger red

  // Cancelled states - Dark red
  Cancelled: "#c82333", // Dark red (permanent failure)

  // Dispatched - Purple
  Dispatched: "#6f42c1", // Purple (dispatched, awaiting delivery)

  // Issue ticket states
  OPEN: "#ffc107", // Amber/yellow (needs attention)
  CLOSE: "#28a745", // Success green (resolved)
} as Record<string, string>;
